import React, { useEffect, useState } from "react";
import styles from "./ProgressBar.module.css";

const ProgressBar = ({ progress }) => {
  const [animatedProgress, setAnimatedProgress] = useState(progress - 25);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimatedProgress(progress);
    }, 100);
    return () => clearTimeout(timeout);
  }, [progress]);

  return (
    <div className={styles.progressBarContainer}>
      <div
        className={`${styles.firstStep} ${
          animatedProgress >= 25 ? styles.completed : ""
        }`}
      />
      <div
        className={`${styles.secondStep} ${
          animatedProgress >= 50 ? styles.completed : ""
        }`}
      />
      <div
        className={`${styles.thirdStep} ${
          animatedProgress >= 75 ? styles.completed : ""
        }`}
      />
      <div
        className={`${styles.fourthStep} ${
          animatedProgress >= 100 ? styles.completed : ""
        }`}
      />
    </div>
  );
};

export default ProgressBar;
